// import { wx as WX } from '@/assets/js/jweixin-1.4.0';
const WX = window.jWeixin;
import { errors } from '@/services';

export default {
	async install(Vue) {
		try {
			if (window.navigator.userAgent.includes('MicroMessenger')) {
				Vue.$wx = WX;
				Vue.prototype.$wx = WX;
			}
		} catch (error) {
			errors(error);
		}
	},
};
